
import {createAsyncThunk} from '@reduxjs/toolkit'
import {getIndividualJobStatus} from 'sr/utils/api/masterData/individualJobStatus/getIndividualJobStatus'
export const fetchindividualJobStatus = createAsyncThunk(
  'getIndividualJobStatus',
  async () => {
    const response = await getIndividualJobStatus()
    return response?.data
  }
)


